import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import { BaseTransformer } from './BaseTransformer';
export var ThreadTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(ThreadTransformer, _BaseTransformer);
  var _super = _createSuper(ThreadTransformer);
  function ThreadTransformer() {
    _classCallCheck(this, ThreadTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(ThreadTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        id: data.record_id,
        project: data.project ? {
          value: data.project.value,
          label: data.project.label
        } : {
          value: null,
          label: ''
        },
        section: data.section ? {
          value: data.section.value,
          label: data.section.label
        } : {
          value: null,
          label: ''
        },
        threadId: data.thread_id,
        brand: data.brand ? {
          value: data.brand.value,
          label: data.brand.label
        } : {
          value: null,
          label: ''
        },
        caseStatus: data.case_status,
        pages: data.pages,
        requestType: {
          value: data.request_type ? data.request_type.value : null,
          label: data.request_type ? data.request_type.label : null
        },
        requestStatus: {
          value: data.request_status ? data.request_status.value : null,
          label: data.request_status ? data.request_status.label : null
        },
        salesInquiryStatus: {
          value: data.sales_inquiry_status ? data.sales_inquiry_status.value : null,
          label: data.sales_inquiry_status ? data.sales_inquiry_status.label : null
        },
        estimatedStartDate: data.estimated_start_date,
        estimatedDeliveryDate: data.estimated_delivery_date,
        estimatedEffort: data.estimated_effort,
        category: data.category && data.category.value,
        subject: data.subject,
        accountName: data.account_name ? {
          recordId: data.account_name.value,
          value: data.account_name.value,
          label: data.account_name.label
        } : {
          recordId: null,
          value: null,
          label: ''
        },
        senderName: data.sender_name,
        senderEmail: data.sender_email,
        relatedData: data.relatedData,
        recordOwner: data.record_owner ? {
          userId: data.record_owner.value,
          label: data.record_owner.label
        } : {
          userId: null,
          label: ''
        },
        createdOn: data.created_on,
        createdBy: data.created_by,
        closedOn: data.closed_on,
        lastMessageDate: data.last_message_date,
        lastMessage: data.last_message,
        messageStatus: data.message_status,
        messageCount: data.message_count,
        firstAssignedTime: data.first_assigned_time,
        incomingChannel: data.incoming_channel,
        notifyOn: data.notify_on,
        notifyMsg: data.notify_msg,
        holdReason: data.hold_reason,
        cc: data.cc ? data.cc.split(",") : [],
        solution: data.solution,
        followers: data.followers && data.followers.length > 0 && typeof data.followers == 'string' ? data.followers.split(",").map(function (k) {
          return k ? parseInt(k.substring(1)) : null;
        }) : data.followers && data.followers[0] ? data.followers.map(function (k) {
          return k && k.id ? parseInt(k.id.substring(1)) : null;
        }) : [],
        bcc: data.bcc ? data.bcc.split(",") : [],
        star: data.star,
        urgent: data.urgent,
        priority: data.priority ? {
          value: data.priority.value,
          label: data.priority.label
        } : {
          value: null,
          label: ''
        },
        timeSinceLastReply: data.time_since_last_reply,
        appUserId: data.app_user_id,
        team: data.team ? {
          teamId: data.team.value,
          label: data.team.label
        } : null,
        sender: data.sender,
        sla_remaining_time_calculated: data.sla_remaining_time_calculated,
        contactName: data.contact_name ? {
          recordId: data.contact_name.value,
          value: data.contact_name.value,
          label: data.contact_name.label
        } : null,
        senderPhone: data.sender_phone,
        requestDescription: data.request_description,
        sla: {
          value: data.sla ? data.sla.value : null,
          label: data.sla ? data.sla.label : null
        },
        slaLevel: {
          value: data.sla_level ? data.sla_level.value : null,
          label: data.sla_level ? data.sla_level.label : null
        },
        newContact: {
          firstname: '',
          lastname: '',
          phone: '',
          email: '',
          account_name: {
            recordId: data.account_name ? data.account_name.value : null,
            label: data.account_name ? data.account_name.label : null
          }
        }
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      var fl = data.followers;
      if (data.followers && data.followers[0]) {
        fl = data.followers.map(function (k) {
          return 'U' + k;
        }).join(",");
      }
      console.log(data);
      var cc = [];
      if (data.cc) {
        cc = data.cc.map(function (k) {
          return k && k.target_email ? k.target_email : k;
        });
      }
      var bcc = [];
      if (data.bcc) {
        bcc = data.bcc.map(function (k) {
          return k && k.target_email ? k.target_email : k;
        });
      }
      return {
        record_id: data.id,
        account_name: data.accountName ? data.accountName.recordId ? data.accountName.recordId : data.accountName.value ? data.accountName.value : null : null,
        case_status: data.caseStatus && data.caseStatus.value,
        request_type: data.requestType && data.requestType.value,
        sales_inquiry_status: data.salesInquiryStatus && data.salesInquiryStatus.value,
        request_status: data.requestStatus && data.requestStatus.value,
        estimated_start_date: data.estimatedStartDate,
        estimated_delivery_date: data.estimatedDeliveryDate,
        estimated_effort: data.estimatedEffort,
        hold_reason: data.holdReason && data.holdReason.value ? data.holdReason.value : data.holdReason,
        pages: data.pages,
        notify_on: data.notifyOn,
        notify_msg: data.notifyMsg,
        priority: data.priority && (data.priority.value || data.priority.value == null) ? data.priority.value : data.priority ? data.priority : '',
        project: data.project && (data.project.value || data.project.value == null) ? data.project.value : data.project ? data.project : '',
        section: data.section && (data.section.value || data.section.value == null) ? data.section.value : data.section ? data.section : '',
        category: data.category ? data.category : '',
        contact_name: data.contactName && data.contactName.recordId ? data.contactName.recordId : data.contactName && data.contactName.value ? data.contactName.value : null,
        incoming_channel: data.incomingChannel && data.incomingChannel.value,
        record_owner: data.recordOwner && data.recordOwner.userId,
        sender: data.sender && data.sender.value,
        sender_email: data.senderEmail,
        sender_name: data.senderName,
        request_description: data.requestDescription,
        followers: fl,
        cc: cc ? cc.join(",") : '',
        bcc: bcc ? bcc.join(",") : '',
        subject: data.subject,
        team: data.team && data.team.teamId ? data.team.teamId : '',
        sla_remaining_time_calculated: data.sla_remaining_time_calculated,
        solution: data.solution,
        sla_level: data.slaLevel && data.slaLevel.value,
        sla: data.sla && data.sla.value
      };
    }
  }]);
  return ThreadTransformer;
}(BaseTransformer);